import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { DarkTheme, mediaQueries } from './Themes'
import { Design, Develope } from './AllSvgs'

import LogoComponent from '../subComponents/LogoComponent'
import SocialIcons from '../subComponents/SocialIcons'
import ParticleComponent from '../subComponents/ParticleComponent'
import BigTitle from '../subComponents/BigTitlte'

const Box = styled.div`
	background-color: ${(props) => props.theme.body};
	width: 100vw;
	height: 100vh;
	position: relative;
	display: flex;
	justify-content: space-evenly;
	align-items: center;

	${mediaQueries(50)`
            flex-direction:column;  
            padding:8rem 0;
height:auto;
            &>*:nth-child(5){
              margin-bottom:5rem;
            }
           
  `};
	${mediaQueries(30)`
           
            &>*:nth-child(5){
              margin-bottom:4rem;
            }
           
  `};
`

const Main = styled.div`
	border: 2px solid #d89216;
	color: #d89216;
	background-color: black;
	padding: 2rem;
	width: 30vw;
	height: 60vh;
	z-index: 3;
	line-height: 1.5;

	font-family: 'Ubuntu Mono', monospace;
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	${mediaQueries(60)`
            height: 55vh;
						margin-bottom: 50px;
  `};

	${mediaQueries(50)`
              width: 50vw;
              height: max-content;

  `};
`

const Title = styled.h2`
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: calc(1em + 1vw);

	& > *:first-child {
		margin-right: 1rem;
	}

	${mediaQueries(60)`
	font-size:calc(0.8em + 1vw);
`};

	${mediaQueries(50)`
	font-size:calc(1em + 2vw);
	margin-bottom:1rem;
`};

	${mediaQueries(30)`
							font-size:calc(1em + 1vw);
`};
	${mediaQueries(25)`
							font-size:calc(0.8em + 1vw);
							svg{
								width:30px;
								height:30px;
							}
`};
`

const Description = styled.div`
	color: #d89216;
	font-size: calc(0.6em + 1vw);
	padding: 0.5rem 0;

	strong {
		margin-bottom: 1rem;
		text-transform: uppercase;
	}
	ul,
	p {
		margin-left: 2rem;
		color: #d89216;
	}

	${mediaQueries(50)`
            font-size: calc(0.8em + 1vw);

  `};

	${mediaQueries(30)`
                      font-size:calc(0.7em + 1vw);

              

  `};

	${mediaQueries(25)`
                      font-size:calc(0.5em + 1vw);

              

  `};
`

const MySkillsPage = () => {
	return (
		<ThemeProvider theme={DarkTheme}>
			<Box>
				<LogoComponent theme="dark" />
				<SocialIcons theme="dark" />
				<ParticleComponent theme="dark" />
				<Main>
					<Title>
						<Design width={40} height={40} fill={'#d89216'} /> Design and
						Animation
					</Title>
					<Description>I’ll help you find the design you like.</Description>
					<Description>
						<strong>Skills</strong>
						<p>Tailwind, SCSS, Material UI, Frame motion, React animations etc.</p>
					</Description>
					<Description>
						<strong>Tools</strong>
						<ul>
							<li>Figma, Figmacrush, Storybook, Codepen</li>
						</ul>
					</Description>
				</Main>
				<Main>
					<Title>
						<Develope width={40} height={40} fill={'#d89216'} /> Front-end
						Developer
					</Title>
					<Description>
						I value brand for which i'm creating and I hope that my expertise
						will help your business.
					</Description>
					<Description>
						<strong>Skills</strong>
						<p>React, Effector, Patronum, Atomic Route, Konva, Lodash etc.</p>
					</Description>
					<Description>
						<strong>Tools</strong>
						<ul>
							<li>VScode, Github, Jira, Postman etc.</li>
						</ul>
					</Description>
				</Main>

				<BigTitle text="SKILLS" top="80%" right="30%" />
			</Box>
		</ThemeProvider>
	)
}

export default MySkillsPage
